// extracted by mini-css-extract-plugin
export default {"input":"List_input__GtmZm","generateButton":"List_generateButton__ekUoG","printButton":"List_printButton__cP92Q","qrContainer":"List_qrContainer__ztY2t"};